import { Box, Card, Grid, List, ListItem, Typography } from '@mui/material';
import { useWebgate } from '@xvia/webgate-connect';

import { useApps } from '@hooks/sample-requests/useApps';

export const SampleAuthRequest = () => {
  const { accessToken } = useWebgate();
  const { data: apps } = useApps(accessToken);

  return (
    <Box>
      <Card
        sx={{
          py: 2,
          px: 6,
        }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography align="center" variant="h5" gutterBottom>
              Requisição autenticada
            </Typography>
            <hr />
            {accessToken ? (
              <Typography component="div">
                <Box fontWeight="bold">
                  <Typography align="center" gutterBottom>
                    Listando os apps cadastrados no Portal
                  </Typography>
                  <Box fontWeight="normal" display="inline">
                    <List dense>
                      {apps?.map((app) => (
                        <Box sx={{ py: 2 }} key={app.id}>
                          <ListItem>
                            <Typography sx={{ mr: 1 }} variant="subtitle1" fontWeight="bold" color="text.primary">
                              ID:
                            </Typography>
                            <Typography variant="subtitle2" color="text.secondary">
                              {app.id}
                            </Typography>
                          </ListItem>
                          <ListItem>
                            <Typography sx={{ mr: 1 }} variant="subtitle1" fontWeight="bold" color="text.primary">
                              Nome:
                            </Typography>
                            <Typography variant="subtitle2" color="text.secondary">
                              {app.name}
                            </Typography>
                          </ListItem>
                          <ListItem>
                            <Typography sx={{ mr: 1 }} variant="subtitle1" fontWeight="bold" color="text.primary">
                              Descrição:
                            </Typography>
                            <Typography variant="subtitle2" color="text.secondary">
                              {app.description}
                            </Typography>
                          </ListItem>
                          <ListItem>
                            <Typography sx={{ mr: 1 }} variant="subtitle1" fontWeight="bold" color="text.primary">
                              Slug:
                            </Typography>
                            <Typography variant="subtitle2" color="text.secondary">
                              {app.slug}
                            </Typography>
                          </ListItem>
                        </Box>
                      ))}
                    </List>
                  </Box>
                </Box>
              </Typography>
            ) : (
              <Typography variant="subtitle1" align="center">
                Inicie a sessão para visualizar a requisição autenticada.
              </Typography>
            )}
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
};
